module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "bg-image img-rounded overflow-hidden push bg-trees"
  }, [_c('div', {
    staticClass: "bg-black-op"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "block block-transparent block-themed text-center"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('h1', {
    staticClass: "h1 font-w700 text-white animated fadeInDown push-5"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('h2', {
    staticClass: "h4 font-w400 text-white-op animated fadeInUp"
  }, [_vm._v("Welcome " + _vm._s(_vm.user.contact.first_name) + " " + _vm._s(_vm.user.contact.last_name))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLeadingAdmin),
      expression: "isLeadingAdmin"
    }],
    staticClass: "row text-uppercase"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Placeholder")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary"
  }, [_vm._v("100")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Awaiting Approval | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('submitted')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-heart"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('submitted')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_submitted))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Post Modified | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('modified')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('modified')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_modified))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Not Yet Submitted | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_not_submitted))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLeadingInspector),
      expression: "isLeadingInspector"
    }],
    staticClass: "row text-uppercase"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Rejected Submissions | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('rejected')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('rejected')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_rejected))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 pull-right"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "font-w700 font-s13 text-gray-darker animated fadeIn"
  }, [_vm._v("Incomplete Inspections | "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(" MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "text-muted animated fadeIn"
  }, [_c('small', [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" TODAY")])]), _vm._v(" "), _c('div', {
    staticClass: "animated flipInX"
  }, [_c('a', {
    staticClass: "h2 font-w300 text-primary",
    on: {
      "click": function($event) {
        _vm.goFilteredInspections('not_submitted')
      }
    }
  }, [_vm._v(_vm._s(_vm.stats.total_not_submitted))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded block-opt-refresh-icon8"
  }, [_c('div', {
    staticClass: "block-content block-content-full",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "inspection-table"
  }, [_c('inspection-list', {
    ref: "recentList",
    attrs: {
      "count": _vm.recentLength,
      "inspections": _vm.inspections,
      "columns": _vm.inspectionListColumns
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "font-w700 font-s15 text-gray-darker"
  }, [_vm._v("Export Inspections")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('wc-date', {
    attrs: {
      "label": "From",
      "neverDirty": true
    },
    model: {
      value: (_vm.exportStartDate),
      callback: function($$v) {
        _vm.exportStartDate = $$v
      },
      expression: "exportStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('wc-date', {
    attrs: {
      "label": "To",
      "neverDirty": true
    },
    model: {
      value: (_vm.exportEndDate),
      callback: function($$v) {
        _vm.exportEndDate = $$v
      },
      expression: "exportEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary pull-right",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportInspections
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" CSV\n                    ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76304229"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/home.vue
// module id = 827
// module chunks = 3